@import '../../../theme.scss';

verdocs-template-role-properties {
  box-sizing: border-box;
  font-family: $primary-font;

  div {
    box-sizing: border-box;
  }

  .heading {
    display: flex;
    font-size: 20px;
    font-weight: 500;
    flex-direction: row;
  }

  .buttons {
    display: flex;
    margin-top: 10px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    verdocs-button {
      margin-left: 16px;
    }
  }

  form {
    gap: 15px;
    padding: 20px;
    display: flex;
    flex-direction: column;

    .instructions {
      margin: 7px 0 0 0;
      font-size: 12px;
      font-style: italic;
    }

    .input-label {
      display: block;
      font-size: 14px;
      flex: 0 0 100px;
      font-weight: 700;
      margin: 0 0 4px 0;
      color: $label-color-light;
    }

    .first-last {
      gap: 15px;
      display: flex;
      flex-direction: row;
    }
  }

  form verdocs-help-icon {
    transform: scale(0.8);
  }

  verdocs-select-input {
    //flex: 1;
    //margin: 0;

    label {
      display: block;
    }
  }

  verdocs-text-input {
    margin: 0;

    label {
      display: block;
    }

    .input-label {
      flex: 0 0 100px;
    }

    input {
      flex: 1;
      display: flex;
    }

    verdocs-text-input {
      margin: 0;
    }
  }

  .checkbox-wrapper {
    flex: 1;
    display: flex;
  }

  .delete-button {
    height: 34px;
    display: flex;
    padding: 0 6px;
    cursor: pointer;
    background: none;
    border-radius: 4px;
    align-items: center;
    border: 1px solid #999;
    justify-content: center;

    svg {
      width: 24px;
      height: 24px;
    }

    &:active {
      background: #f3f3f3;
    }
  }
}
